import React from 'react';
import { useLocation } from 'react-router-dom';

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
  Stack,
  Text,
} from '@eluve/components';

import { useSchemaValidation } from '../useCreateTemplate';

import { SchemaValidationDialog } from './SchemaValidationDialog';

export interface TemplateEditingPageHeaderButtonsProps {
  saveDraftDisabled?: boolean;
  submitDisabled?: boolean;
  handleSaveDraft: () => void;
  handleSubmit: () => void;
  handleDeleteDraft: () => void;
}

export const TemplateEditingPageHeaderButtons: React.FC<
  TemplateEditingPageHeaderButtonsProps
> = ({
  handleSaveDraft,
  handleSubmit,
  handleDeleteDraft,
  saveDraftDisabled = false,
  submitDisabled = false,
}) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.includes('/admin/');

  const {
    handleValidateSchema,
    isValidating,
    validationResults,
    isValidationDialogOpen,
    setIsValidationDialogOpen,
  } = useSchemaValidation();

  return (
    <>
      <Stack justify="end" gap={2} direction="horizontal">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost">
              <Icon name="MoreHorizontal" size="auto" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            {isAdminRoute && (
              <DropdownMenuItem onClick={handleValidateSchema}>
                <Stack gap={2} direction="horizontal">
                  <Icon name="ShieldCheck" size="lg" />
                  <Text size="md" inline>
                    Validate Schema
                  </Text>
                </Stack>
              </DropdownMenuItem>
            )}
            <DropdownMenuItem onClick={handleDeleteDraft}>
              <Stack gap={2} direction="horizontal">
                <Icon
                  name="Trash"
                  className="text-text-negative-subtle"
                  size="lg"
                />
                <Text size="md" inline className="text-text-negative-subtle">
                  Delete Draft
                </Text>
              </Stack>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>

        <Button
          variant="outline"
          disabled={saveDraftDisabled || isValidating}
          onClick={handleSaveDraft}
        >
          Save Draft
        </Button>
        <Button
          disabled={submitDisabled || isValidating}
          onClick={handleSubmit}
        >
          <Icon name="Upload" size="auto" />
          Submit Template
        </Button>
      </Stack>

      <SchemaValidationDialog
        open={isValidationDialogOpen}
        onOpenChange={setIsValidationDialogOpen}
        isValidating={isValidating}
        validationResults={validationResults}
      />
    </>
  );
};
